import { StatusTag } from "@/molecules/StatusTag"
import { getEnforcementStatus } from "@/pages/GovernancePage/applications/policies/useAiPolicies.selector"

import type { TFunction } from "@/hooks/useTranslation"
import type { Record } from "@/pages/GovernancePage/applications/policies/getDemoData.types"

export const EnforcementCell = (t: TFunction) =>
  function EnforcementCellComponent(_: unknown, record: Record) {
    const status = getEnforcementStatus(record)

    if (!status) return null

    return (
      <StatusTag
        status={status === "enforced" ? "success" : "neutral"}
        text={t(`governance.ai.enforce.status.${status}`)}
      />
    )
  }
